import { ContentState, EditorState } from "draft-js";
import getCompositeDecorator from "../../../components/CustomRevvEditor/decorator";
import AddDocComponentCommand from "../addComponentCommandBase/addDocComponentCommand";
import { getContentStateFromRawSectionData } from "../../../utils/components";

class AddDocHTMLComponentCommand extends AddDocComponentCommand {
  constructor(componentData, mode) {
    super(componentData, mode);
    this.componentData = componentData;
    this.mode = mode;
  }

  addClickedSection() {
    const { component } = this.componentData;
    if (component) {
      super.activeComponent = component;
    }
  }

  addClickedEditorState() {
    const { component } = this.componentData;
    let contentState = component.data;
    if (!(contentState instanceof ContentState)) {
      contentState = getContentStateFromRawSectionData(component, this.mode);
    }
    if (contentState) {
      super.activeEditorState = EditorState.createWithContent(
        contentState,
        getCompositeDecorator(),
      );
    }
  }

  execute() {
    // 1.
    // this.addClickedSection();
    // // 2.
    // this.addClickedEditorState();
    // ----------- add component to document super class ---------
    super.execute();
  }

  undo() {
    super.undo();
  }
}

export default AddDocHTMLComponentCommand;
